var $$ = $$ || {};

$$.Auth = class Auth {
	constructor (root) {
		this.root = root;

		this.formStates = {
			closed: 'g-icon-eye-closed',
			opened: 'g-icon-eye-opened'
		};

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			eye: this.root.find('.js-eye'),
			passwordInput: this.root.find('.js-password-input'),
			enter: this.root.find('.js-enter'),
			profile: this.root.find('.js-profile')
		};
	}

	_bindEvents () {
		this.nodes.eye.on('click', () => {
			this._togglePasswordInput();
		});

		this.root.validate({
			submitHandler: (form) => {
				form = $(form);

				$.ajax({
					url:     form.attr('action'),
					method:  form.attr('method'),
					data:    form.serialize(),
					success: (response) => {
						response = $.parseJSON(response);

						if (response.errors) {
							_.each(response.errors, function (value, key) {
								var input = form.find(`input[name="${key}"]`).addClass('error');
								var error = $('<label class="error">' + value + '</label>');

								error.insertAfter(input);
							});
						} else if (response.redirect) {
							window.location.href = response.redirect;
						}
					}
				});
			}
		});
	}

	_ready () {
		var parameters = $$.parseUrlParams(location.href);
		var auth = parameters.auth;

		if ('auth' in parameters && auth.toString() === 'true') {
			this.nodes.enter.addClass('hidden');
			this.nodes.profile.removeClass('hidden');
		}
	}

	_togglePasswordInput () {
		if (this.nodes.eye.hasClass(this.formStates.opened)) {
			this.nodes.eye.removeClass(this.formStates.opened);
			this.nodes.eye.addClass(this.formStates.closed);
			this.nodes.passwordInput.attr('type', 'password');
		} else if (this.nodes.eye.hasClass(this.formStates.closed)) {
			this.nodes.eye.removeClass(this.formStates.closed);
			this.nodes.eye.addClass(this.formStates.opened);
			this.nodes.passwordInput.attr('type', 'text');
		}
	}
};
